import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import {
  IReducerActionWithCallback,
  IReducerWithCallbackParams,
} from "Shared/Types/shared";

const getAnnouncementsList = createAsyncThunk(
  "announcements/getAnnouncementsList",
  async ({ params, onError, onSuccess }: IReducerWithCallbackParams) => {
    try {
      const response = await api.announcements.getAnnouncements(params);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);
const markAsRead = createAsyncThunk(
  "announcements/markAsRead",
  async (id: string) => {
    try {
      const response = await api.announcements.markAnnouncementAsRead(id);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const getUnreadCount = createAsyncThunk(
  "announcements/getUnreadCount",
  async () => {
    try {
      const response = await api.announcements.getUnreadCount();
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
const markAsReadAll = createAsyncThunk(
  "announcements/markAsReadAll",
  async ({ onError, onSuccess }: IReducerActionWithCallback) => {
    try {
      const response = await api.announcements.markAnnouncementAsReadAll();
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      throw error;
    }
  },
);
export { getAnnouncementsList, markAsRead, getUnreadCount, markAsReadAll };
